












import {Component, Prop, Vue} from 'vue-property-decorator';

// eslint-disable-next-line no-unused-vars
import {StatementType} from '@/types/services';
import {RouteName} from '@/router';
import {noticeRecoveryRegion, statementTypeToIsDistrict} from '@/app.config';

@Component({
  computed: {
    StatementType() {
      return StatementType
    },
  }
})
export default class AltDistrictButton extends Vue {
  @Prop({ default: ()=>{} }) parentStatement!: any;

  private showDistrictButton: boolean = false;
  private statementId!: string;
  private statementType!: StatementType;

  get noticeRecoveryRegion() {
    return noticeRecoveryRegion && this.statementType === StatementType.NOTICE_RECOVERY
  }

  mounted() {
    this.statementId = this.$route.params.id;
    this.statementType = this.parentStatement.statementType;

    this.showDistrictButton =
      statementTypeToIsDistrict[this.statementType] &&
      ['NOT_DISTRIBUTED'].includes(this.parentStatement.statusCode);
  }

  goDistrictPage() {
    this.$router.push({
      name: RouteName.ALTERNATIVE_SERVICE_DISTRICT,
      params: { parentStatementId: this.statementId },
    });
  }
}
